<template>
    <span class="Logout pointer" @click="LogoutApp">
        <font-awesome-icon :icon="['fa', 'sign-out-alt']" /> Logout
    </span>
</template>
<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSignOutAlt);

    export default {
        methods: {
            LogoutApp() {
                this.$MasterAPI.ExecuteRequest("POST", "Core/User/Logout", null, this.LogoutAppSuccess, () => { }, false);
            },
            LogoutAppSuccess(response) {
                if (response.data.data == "local") {
                    location.reload();
                } else if (response.data.data == "ad") {
                    let signouturl = encodeURI(this.$baseURL + "/");
                    window.location = "https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=" + signouturl
                }
                
            },

        }
    };
</script>
<style scoped>
    
</style>